/**
 * @generated SignedSource<<f2e4c6e15069695a0fbd7c61f3facf2c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EntityWithPositionInput = {
  id: string;
  position?: number | null;
};
export type DepartureLocationsListSortMutation$variables = {
  positions: ReadonlyArray<EntityWithPositionInput>;
};
export type DepartureLocationsListSortMutation$data = {
  readonly updateDepartureLocationPositions: boolean;
};
export type DepartureLocationsListSortMutation = {
  response: DepartureLocationsListSortMutation$data;
  variables: DepartureLocationsListSortMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "positions"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "positions",
        "variableName": "positions"
      }
    ],
    "kind": "ScalarField",
    "name": "updateDepartureLocationPositions",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DepartureLocationsListSortMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DepartureLocationsListSortMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7e73ec2167a4f94785176bd6e0cd76ab",
    "id": null,
    "metadata": {},
    "name": "DepartureLocationsListSortMutation",
    "operationKind": "mutation",
    "text": "mutation DepartureLocationsListSortMutation(\n  $positions: [EntityWithPositionInput!]!\n) {\n  updateDepartureLocationPositions(positions: $positions)\n}\n"
  }
};
})();

(node as any).hash = "cdc3ab0c86fa541640aea1d2a4543227";

export default node;
